// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_d6-2";
export var aiChatCartContainerExit = "_d6-4";
export var aiChatContainerLarge = "_d6-0";
export var aiChatContainerSmall = "_d6-1";
export var aiChatIcon = "_d6-6";
export var slideInFromRight = "_d6-3";
export var slideOutToRight = "_d6-5";